import { gql } from '@apollo/client';

export const GET_LATEST_DRAFT_NEXT_STEP = gql`
  query GetLatestDraftNextStep($patientId: ID!) {
    latestDraftNextStep(patientId: $patientId) {
      id
      patientId
      nextStep
      nextAppointmentType
      nextAppointmentMethod
      timingValue
      timingUnit
      comments
      status
      submittedAt
      practitionerId
      createdAt
      updatedAt
    }
  }
`;
